<script lang="ts">
  export let subheading: string = '';
</script>

<style lang="postcss">
  h2 {
    margin: 0.5rem 0 0.75rem;
  }

  @media (min-width: 768px) {
    h2 {
      width: 25%;
      text-align: right;
    }
  }
</style>

<h2>{subheading}</h2>
